export default {
  props: {
    // 问题中的图片
    imgUrl: {
      type: Array,
      default: () => {
        return []
      }
    },
    // 只显示题目 未提交 不显示答案
    // answerShow: {
    //     type: Boolean,
    //     default: true
    // },
    // 上一章节按钮
    prevState: {
      type: Boolean,
      default: true
    },
    // 下一章节按钮
    nextState: {
      type: Boolean,
      default: true
    },
    // 上一章节id
    prevChapterId: {
      type: String | Number
    },
    // 下一章节id
    nextChapterId: {
      type: String | Number
    },
    //上一章节类型
    prevType: {
      type: String | Number
    },
    nextType: {
      type: String | Number
    },
  },
  methods: {
    // 查看大图
    lookBgImg(src) {
      this.imgActive = src;
    },
    // 关闭图片
    closeImg() {
      this.imgActive = null;
    },
    checkChapter(e, cur_chap_index, cur_part_index) {
      this.$store.commit('videoTime', 0)
      this.$store.commit('videoHeadTime', 0)
      /* 上下章节切换 */
      this.cur_xj_index = Number(cur_chap_index);
      this.cur_zj_index = Number(cur_part_index);
      if (e == 'prev') {
        // 上一章节
        if (this.cur_xj_index != 0) {
          this.cur_xj_index--;
        } else {
          this.cur_zj_index--;
          this.cur_xj_index = this.data.part_list[this.cur_zj_index].chapter_list.length - 1;
        }
      } else {
        // 下一章节
        if (this.cur_xj_index == this.data.part_list[this.cur_zj_index].chapter_list.length - 1 && this.cur_zj_index < this.data.part_list.length - 1) {
          this.cur_zj_index++;
          this.cur_xj_index = 0;
          // this.cur_xj_index++;
        } else {
          this.cur_xj_index++;
        }

      }
      let cur_data = this.data.part_list[this.cur_zj_index].chapter_list[this.cur_xj_index]
      if(cur_data.chapter_content && cur_data.chapter_content.dry){
        // console.log(6666,cur_data.chapter_content.dry);
        for(let i=0;i<cur_data.chapter_content.dry.length;i++){
          // 如果没提交 点击上下章节的时候清空答案
          cur_data.chapter_content.dry[i].answer = "";
          delete cur_data.chapter_content.dry[i].isChosed
        }
      }
      
      this.$store.commit('cur_data', cur_data);
      // console.log(this.$store.state.cur_data.chapter_content.dry);
      
      if(this.cur_xj_index < this.data.part_list[this.cur_zj_index].chapter_list.length - 1) {
        this.$store.commit('next_data', this.data.part_list[this.cur_zj_index].chapter_list[(this.cur_xj_index + 1)])
      } else {
        if(this.cur_zj_index < this.data.part_list.length -1 ) {
          this.$store.commit('next_data', this.data.part_list[this.cur_zj_index +1].chapter_list[0])
        } else {
          this.$store.commit('next_data', cur_data)
        }
      }
      this.$store.commit('currentPartIndex', this.cur_zj_index)
      this.$store.commit('currentChapterIndex', this.cur_xj_index)

      let checkedChapterType = cur_data.chapter_type;
      cur_data.answerShow = false; //答案不显示

      let chapterNumCurs, chapterNum = 0;
      data.part_list.forEach((_e, i) => {
        // debugger
        if (this.cur_zj_index > i) {
          chapterNum += parseInt(_e.chapter_list.length)
        }
        if (this.cur_zj_index == 0) {
          chapterNumCurs = parseInt(this.cur_xj_index)
        } else {
          chapterNumCurs = parseInt(this.cur_xj_index) + chapterNum
        }
      })
      this.$store.commit('chapterNumCur', chapterNumCurs);
      if (this.$route.name == 'video_d' || this.$route.name == 'tuwen_d' || this.$route.name == 'minitest') {
        //竖屏
        // debugger
        if (checkedChapterType == 1) {
          this.$router.replace({path:'/h5Dindex/video',query: { chapter_id: this.cur_data.chapter_id }})

        } else if (checkedChapterType == 4) {
          this.$router.replace({path: '/h5Dindex/tuwen',query: { chapter_id: this.cur_data.chapter_id }})

        } else {
          this.getChapterAnswer();//取答案数据
          // this.$forceUpdate()
          this.$router.replace({ path: '/h5Dindex/test', query: { chapter_id: this.cur_data.chapter_id } })
        }
      } else {
        // 横屏
        if (checkedChapterType == 1) {
          this.$router.replace({path: '/h5Rindex/video', query: { chapter_id: this.cur_data.chapter_id }});
        } else if (checkedChapterType == 4) {
          this.$router.replace({path: '/h5Rindex/tuwen',query: { chapter_id: this.cur_data.chapter_id }});
        } else {
          this.getChapterAnswer();//取答案数据
          this.$router.replace({ path: '/h5Rindex/test', query: { chapter_id: this.cur_data.chapter_id } });
        }
      }
    },
    lookHeadVideo() {
      if (this.$route.name == 'video_d' || this.$route.name == 'tuwen_d' || this.$route.name == 'minitest') {
          //竖屏
          this.$router.replace({
            path: '/h5Dindex/headVideo'
          })
        } else {
          // 横屏
          this.$router.replace('/h5Rindex/headVideo');
        }
    },
    lookFootVideo() {
      if (this.$route.name == 'video_d' || this.$route.name == 'tuwen_d' || this.$route.name == 'minitest') {
          //竖屏
          this.$router.replace({
            path: '/h5Dindex/footVideo'
          })
      } else {
          // 横屏
          this.$router.replace('/h5Rindex/footVideo');
      }
    },
  }
}
